var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { combineLatest } from "rxjs";
import { collection } from "rxfire/firestore";
import { mapList } from "@/shared/RxOperators";
import { deserializeTweet } from "@/data/util/Serialization";
import { toPlainObject } from "@/shared/ObjectUtil";
import { FieldValue } from "@/data/Firebase";
import { split } from "@/shared/ArrayUtil";
import { map } from "rxjs/operators";
function documentSnapshotToTweet(snapshot) {
    return deserializeTweet(snapshot.id, snapshot.data({ serverTimestamps: "estimate" }));
}
export class TweetRepositoryImpl {
    constructor(db) {
        this.db = db;
        this.tweetsCollection = db.collection("tweets");
    }
    getTweetsByUserIds(userIds) {
        const splitIds = split(userIds, 10);
        const observables = splitIds.map(ids => this.getTweetsByUsers(ids));
        return combineLatest(observables).pipe(map(list => list.flat()), mapList(documentSnapshotToTweet), map(list => list.sort((one, other) => other.date.getTime() - one.date.getTime())));
    }
    getTweetsByUsers(userIds) {
        const query = this.tweetsCollection
            .where("author.id", "in", userIds)
            .orderBy("date", "desc");
        return collection(query);
    }
    addTweet(tweet) {
        const { id } = tweet, tweetWithoutId = __rest(tweet, ["id"]);
        const plainTweet = toPlainObject(tweetWithoutId);
        const tweetWithTimestamp = Object.assign(Object.assign({}, plainTweet), { date: FieldValue.serverTimestamp() });
        return this.tweetsCollection.add(tweetWithTimestamp).then(() => { });
    }
    likeTweet(tweetId, userId) {
        return this.tweetsCollection.doc(tweetId).update("likedBy", FieldValue.arrayUnion(userId));
    }
    unlikeTweet(tweetId, userId) {
        return this.tweetsCollection.doc(tweetId).update("likedBy", FieldValue.arrayRemove(userId));
    }
}
